import { render, staticRenderFns } from "./InformationDisplay.vue?vue&type=template&id=e4454c5c&scoped=true&"
import script from "./InformationDisplay.vue?vue&type=script&lang=js&"
export * from "./InformationDisplay.vue?vue&type=script&lang=js&"
import style0 from "./InformationDisplay.vue?vue&type=style&index=0&id=e4454c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4454c5c",
  null
  
)

export default component.exports